<template>
	<div>
		<vs-button
			class="font-bold"
			color="primary"
			icon-pack="feather"
			icon="icon-list"
			size="small"
			type="flat"
			@click.prevent="popupVehicle = true"
			><small style="font-size: 13px">{{ $t("Select") }}</small>
		</vs-button>
		<vs-popup class="SelectVehicle" :title="$t('Vehicles.Vehicles')" :active.sync="popupVehicle">
			<vs-row>
				<vs-col vs-w="12">
					<h4>{{ $t("Vehicles.AssigneVehicleText") }}</h4>
				</vs-col>
				<vs-col vs-w="12" id="div-with-loading" class="vs-con-loading__container">
					<vs-table
						v-model="selected"
						multiple
						pagination
						max-items="10"
						search
						:key="key"
						:data="vehicleList"
					>
						<div slot="header" class="flex flex-reverse items-center flex-grow justify-between">
							<vs-button @click="saveSourceList()">
								{{ $t("Select") }}
							</vs-button>
						</div>
						<template slot="thead">
							<vs-th>{{ $t("Identification") }}</vs-th>
						</template>
						<template slot-scope="{data}">
							<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
								<vs-td :data="data[indextr]">
									{{ data[indextr].identification }}
								</vs-td>
							</vs-tr>
						</template>
					</vs-table>
				</vs-col>
			</vs-row>
		</vs-popup>
	</div>
</template>

<script>
export default {
	name: "SelectVehicle",
	data() {
		return {
			popupVehicle: false,
			selected: [],
			key: 1,
		};
	},
	props: {
		// Función para devolver el listado de recursos seleccionados.
		addVehicle: Function,
		// Función para eliminar un elemento del array.
		deleteVehicle: Function,
	},
	computed: {
		vehicleList() {
			return this.$store.state.moduleOptimization.standardInputList["vehicles"] === undefined ||
				this.$store.state.moduleOptimization.standardInputList["vehicles"] === "" ||
				this.$store.state.moduleOptimization.standardInputList["vehicles"] === null
				? []
				: this.$store.state.moduleOptimization.standardInputList["vehicles"];
		},
	},
	watch: {
		vehicleList(newval) {
			if (newval.length > 0) {
				this.$vs.loading.close("#div-with-loading > .con-vs-loading");
			}
		},
		popupVehicle(val) {
			if (val) {
				this.selected = [];
			}
		},
	},
	methods: {
		saveSourceList() {
			// Hacemos una copía del array, ya que los datos los estamos trayendo directamente desde el store y generará error si modificamos algo
			const copy = this.selected.map((b, idx) => Object.assign({index: idx}, b));
			this.addVehicle(copy, this.selected);
			this.popupVehicle = false;
		},
	},
	mounted() {
		if (this.vehicleList.length < 0) {
			this.$vs.loading({
				container: "#div-with-loading",
				scale: 1,
				type: "sound",
			});
		}
	},
};
</script>
